export const createEmptyDataSetForChart = () => {
  return [];
};
